import fp from 'lodash/fp';
import * as dateFnsCompat from 'utils/date-fns-compat';

export const addYears = fp.rearg([1, 0])(dateFnsCompat.addYears);
export const differenceInCalendarDays = fp.rearg([1, 0])(dateFnsCompat.differenceInCalendarDays);
export const differenceInCalendarWeeks = fp.rearg([2, 0, 1])(dateFnsCompat.differenceInCalendarWeeks);
export const setDate = fp.rearg([1, 0])(dateFnsCompat.setDate);
export const setMonth = fp.rearg([1, 0])(dateFnsCompat.setMonth);
export const setYear = fp.rearg([1, 0])(dateFnsCompat.setYear);



// WEBPACK FOOTER //
// ./src/utils/date-fns.js